module.exports = __webpack_public_path__ + "static/media/benefitCloudLeft.4c3609e6.svg";